<div class="hc-dropdown" [class.hc-dropdown--open]="isOpen">
  <!-- Trigger (slotted content with [trigger] attribute) -->
  <div
    class="hc-dropdown__trigger"
    (click)="toggle($event)"
    (keydown.enter)="toggle($event)"
    (keydown.space)="toggle($event)"
    tabindex="0"
    role="button">
    <ng-content select="[trigger]"></ng-content>
  </div>

  <!-- Menu -->
  @if (isOpen) {
    <div
      class="hc-dropdown__menu"
      [ngClass]="positionClasses"
      [style.minWidth]="minWidth"
      role="menu"
      >
      <!-- Custom template -->
      @if (menuTemplate) {
        <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
      } @else {
        @for (item of items; track trackById($index, item)) {
          <!-- Divider -->
          @if (item.divider) {
            <div class="hc-dropdown__divider"></div>
          }
          <!-- Menu Item -->
          @if (!item.divider) {
            <button
              type="button"
              class="hc-dropdown__item"
              [class.hc-dropdown__item--disabled]="item.disabled"
              [disabled]="item.disabled"
              (click)="onItemClick(item, $event)"
              role="menuitem"
              >
              @if (item.icon) {
                <lucide-icon class="hc-dropdown__icon" [name]="item.icon"></lucide-icon>
              }
              <span class="hc-dropdown__label">{{ item.label }}</span>
            </button>
          }
        }
      }
      <!-- Default menu with items -->
    </div>
  }
</div>
